import { faSortDown, faSortUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import { cloneDeep, get, set } from "lodash";
import React, { useState } from "react";
import {
  FieldInputDollar,
  FieldInputDollarBox,
  SearchComponent,
  WithdrawalExpandableCard,
} from "../../../components";
import Table from "../../../components/CsplTable/CsplTable";
import {
  distributionFormFields,
  manageDistributionFormNames,
} from "../../../utils";
import {
  CalculateInvestmentProrationSplitup,
  CalculateTotalFees,
  getVestedBalanceWithoutVestingMultiplier,
  feeAndTaxesModel,
  getValues,
  taxCalculationForGrossForEachSource,
  taxCalculationForNetForEachSource,
} from "./DistributionConstantsAndFunctions";

const columns = [
  {
    label: "Investment Name",
    columnName: "investmentName",
    width: "20%",
  },
  {
    label: "Available Amount",
    columnName: "investmentAvailableAmount",
    width: "20%",
  },
  {
    label: "Nav",
    columnName: "nav",
    width: "7%",
  },
  {
    label: "Units",
    columnName: "units",
    width: "7%",
  },
  {
    label: "Gross withdrawal",
    columnName: "investmentGrossWithdrawalAmount",
    width: "20%",
  },
  {
    label: "Net withdrawal",
    columnName: "investmentNetWithdrawalAmount",
    width: "20%",
  },
];

const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
const fields = distributionFormFields[formName];

function SourceAllocationTableComponent(props) {
  const {
    values,
    setFieldValue,
    style = {},
    isCustomSourceAllocation,
    singleSourceBalance,
    filteredSourceBalances,
    handleChange,
    requestedAmountEffective,
    grossAmountEffective,
    availableBalanceMapForEachSourceInvestment,
    ...rest
  } = props;
  console.log("singleSourceBalance", singleSourceBalance);
  const feeAndTaxes = feeAndTaxesModel(values);
  const totalFees = CalculateTotalFees(feeAndTaxes);
  const totalAvailableVestedBalance = getVestedBalanceWithoutVestingMultiplier(
    availableBalanceMapForEachSourceInvestment
  );
  const sourceAvailableFromFilteredSourceBalances = availableBalanceMapForEachSourceInvestment.find(
    (_) => _.sourceId === singleSourceBalance.sourceId
  );

  const allocatedSourceWithdrawal =
    values[fields.allocatedSourceWithdrawal] ?? [];
  const sourceIndex = allocatedSourceWithdrawal.findIndex(
    (_) => _.sourceId === singleSourceBalance.sourceId
  );
  const fieldNameForSpecificSourceAllocation = `${fields.allocatedSourceWithdrawal}.${sourceIndex}.sourceEmployeeMap.sourceWithdrawalAmount`;
  const sourceProratedFee =
    (sourceAvailableFromFilteredSourceBalances?.sourceEmployeeMap
      ?.sourceWithdrawalAmount /
      totalAvailableVestedBalance) *
    totalFees;
  const taxCalculationForSource = taxCalculationForGrossForEachSource(
    singleSourceBalance,
    feeAndTaxes
  );
  console.log(
    "taxCalculationForSource",
    taxCalculationForSource,
    taxCalculationForSource?.sourceName
  );
  const grossAmountWithdrawnFromSource =
    getValues(taxCalculationForSource?.sourceEmployeeMap?.accountBalance) +
    sourceProratedFee;
  const netAmountWithdrawnFromSource =
    singleSourceBalance?.sourceEmployeeMap?.sourceWithdrawalAmount;
  let availableSourceInvestmentBalances = get(
    sourceAvailableFromFilteredSourceBalances,
    "sourceInvestmentBalances"
  );

  const onSourceAllocationAmountChange = (event) => {
    let value = parseFloat(event.target.value);
    value = isNaN(value) ? "" : value;
    let tempAllocatedSourceWithdrawal = cloneDeep(
      get(values, `allocatedSourceWithdrawal.${sourceIndex}`, {})
    );
    const taxCalculationForThisSource = taxCalculationForNetForEachSource(
      sourceAvailableFromFilteredSourceBalances,
      feeAndTaxes
    );
    let availableSourceEmployeeMap = get(
      taxCalculationForThisSource,
      "sourceEmployeeMap"
    );
    let sourceEmplyeeMap = get(
      tempAllocatedSourceWithdrawal,
      "sourceEmployeeMap"
    );
    sourceEmplyeeMap.basisCCBBalance =
      (availableSourceEmployeeMap.basisCCBBalance * value) /
      availableSourceEmployeeMap.accountBalance;
    sourceEmplyeeMap.regularEarningsBalance =
      (availableSourceEmployeeMap.regularEarningsBalance * value) /
      availableSourceEmployeeMap.accountBalance;
    sourceEmplyeeMap.repaymentEarningsBalance =
      (availableSourceEmployeeMap.repaymentEarningsBalance * value) /
      availableSourceEmployeeMap.accountBalance;
    sourceEmplyeeMap.basisEarningsBalance =
      (availableSourceEmployeeMap.basisEarningsBalance * value) /
      availableSourceEmployeeMap.accountBalance;
    sourceEmplyeeMap.regularCCBBalance =
      (availableSourceEmployeeMap.regularCCBBalance * value) /
      availableSourceEmployeeMap.accountBalance;
    sourceEmplyeeMap.repaymentCCBBalance =
      (availableSourceEmployeeMap.repaymentCCBBalance * value) /
      availableSourceEmployeeMap.accountBalance;
    sourceEmplyeeMap.regularAccountBalance =
      sourceEmplyeeMap.regularCCBBalance +
      sourceEmplyeeMap.regularEarningsBalance;
    sourceEmplyeeMap.basisAccountBalance =
      sourceEmplyeeMap.basisCCBBalance + sourceEmplyeeMap.basisEarningsBalance;
    sourceEmplyeeMap.repaymentAccountBalance =
      sourceEmplyeeMap.repaymentCCBBalance +
      sourceEmplyeeMap.repaymentEarningsBalance;
    sourceEmplyeeMap.accountBalance =
      sourceEmplyeeMap.repaymentAccountBalance +
      sourceEmplyeeMap.basisAccountBalance +
      sourceEmplyeeMap.regularAccountBalance;
    sourceEmplyeeMap.sourceWithdrawalAmount = value;

    tempAllocatedSourceWithdrawal.sourceInvestmentBalances = tempAllocatedSourceWithdrawal.sourceInvestmentBalances.map(
      (investment) => {
        let availableSourceEmployeeInvestmentMap = availableSourceInvestmentBalances.find(
          (_) => _.investmentId === investment.investmentId
        ).sourceEmployeeInvestmentMap;
        var newInv = { ...investment };
        let newInvestmentMap = get(investment, "sourceEmployeeInvestmentMap");
        newInvestmentMap.regularCCBBalance =
          (availableSourceEmployeeInvestmentMap.regularCCBBalance * value) /
          availableSourceEmployeeMap.accountBalance;
        newInvestmentMap.repaymentCCBBalance =
          (availableSourceEmployeeInvestmentMap.repaymentCCBBalance * value) /
          availableSourceEmployeeMap.accountBalance;
        newInvestmentMap.basisCCBBalance =
          (availableSourceEmployeeInvestmentMap.basisCCBBalance * value) /
          availableSourceEmployeeMap.accountBalance;
        newInvestmentMap.regularEarningsBalance =
          (availableSourceEmployeeInvestmentMap.regularEarningsBalance *
            value) /
          availableSourceEmployeeMap.accountBalance;
        newInvestmentMap.repaymentEarningsBalance =
          (availableSourceEmployeeInvestmentMap.repaymentEarningsBalance *
            value) /
          availableSourceEmployeeMap.accountBalance;
        newInvestmentMap.basisEarningsBalance =
          (availableSourceEmployeeInvestmentMap.basisEarningsBalance * value) /
          availableSourceEmployeeMap.accountBalance;
        newInvestmentMap.regularAccountBalance =
          newInvestmentMap.regularCCBBalance +
          newInvestmentMap.regularEarningsBalance;
        newInvestmentMap.basisAccountBalance =
          newInvestmentMap.basisCCBBalance +
          newInvestmentMap.basisEarningsBalance;
        newInvestmentMap.repaymentAccountBalance =
          newInvestmentMap.repaymentCCBBalance +
          newInvestmentMap.repaymentEarningsBalance;
        newInvestmentMap.accountBalance =
          newInvestmentMap.repaymentAccountBalance +
          newInvestmentMap.basisAccountBalance +
          newInvestmentMap.regularAccountBalance;
        newInv.sourceEmployeeInvestmentMap = newInvestmentMap;
        return newInv;
      }
    );
    set(tempAllocatedSourceWithdrawal, "sourceEmployeeMap", sourceEmplyeeMap);

    setFieldValue(
      `allocatedSourceWithdrawal.${sourceIndex}`,
      tempAllocatedSourceWithdrawal
    );
  };

  const headerData = {
    sourceName: singleSourceBalance?.sourceName,
    availableAmount:
      sourceAvailableFromFilteredSourceBalances?.sourceEmployeeMap
        ?.sourceWithdrawalAmount ?? 0,
    grossWithdrawal: getValues(grossAmountWithdrawnFromSource),
    netWithdrawal: getValues(netAmountWithdrawnFromSource),
    fieldNameForSpecificSourceAllocation: fieldNameForSpecificSourceAllocation,
    maximumWithdrawableAmount:
      sourceAvailableFromFilteredSourceBalances?.sourceEmployeeMap
        ?.sourceWithdrawalAmount,
    onSourceAllocationAmountChange: onSourceAllocationAmountChange,
  };
  const [isExpandable, setIsExpandable] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredAllocatedInvestmentWithdrawals =
    singleSourceBalance?.sourceInvestmentBalances;

  CalculateInvestmentProrationSplitup(
    sourceAvailableFromFilteredSourceBalances,
    { accountBalance: grossAmountWithdrawnFromSource },
    sourceAvailableFromFilteredSourceBalances?.sourceEmployeeMap
  ).filter((_) =>
    (_.investmentName ?? "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  // get(
  //   singleSourceBalance,
  //   "sourceEmployeeMap.sourceEmployeeInvestmentMaps",
  //   []
  // )
  return (
    <>
      <WithdrawalExpandableCard
        className="source-allocation-table-component"
        headerData={headerData}
        isExpandable={isExpandable}
        setIsExpandable={setIsExpandable}
        isCustomSource={
          isCustomSourceAllocation &&
          values[fields.customizeAllocationCalculationMethod] === 1
        }
        style={style}
        values={values}
        setFieldValue={setFieldValue}
        handleChange={handleChange}
      >
        <div className="wd-expandable-children">
          <div className="p-2 withdrawalbackground">
            <SearchComponent
              onSearchChange={(value) => {
                setSearchTerm(value);
              }}
            />
            <span className="ft-12 withdrawalTextColor">
              {filteredAllocatedInvestmentWithdrawals.length} Records Found
            </span>
          </div>
          <div>
            <div className="header-tile pl-2 pr-2 w-100">
              {columns.map((_, ind) => (
                <div
                  style={{ width: _?.width }}
                  className="withdrawal-Text-Color d-flex"
                >
                  {_?.label}{" "}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: "8px",
                      marginTop: "-3px",
                    }}
                  >
                    {/* <div style={{ height: "7.5px", overflow: "visible" }}> */}
                    <FontAwesomeIcon
                      icon={faSortUp}
                      size="xs"
                      style={{ cursor: "pointer" }}
                      // onClick={() => {
                      //   let temp = investmentAllocationData
                      //     .sort((x) => x[_.columnName])
                      //     .reverse();
                      //   setInvestmentAllocationData(temp);
                      // }}
                    />
                    {/* </div> */}
                    <FontAwesomeIcon
                      icon={faSortDown}
                      size="xs"
                      style={{ cursor: "pointer" }}
                      // onClick={() => {
                      //   let temp = investmentAllocationData.sort(
                      //     (x) => x[_.columnName]
                      //   );
                      //   setInvestmentAllocationData(temp);
                      // }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <Table className="source-allocation-table-component">
              <Table.Tbody>
                {filteredAllocatedInvestmentWithdrawals.map((_, ind) => {
                  return (
                    <Table.Tr
                      style={{ width: "100%" }}
                      className={ind % 2 === 0 ? "grey-style" : "white-style"}
                    >
                      {columns.map((col, index) => {
                        if (col.columnName === "netWithdrawal") {
                          return (
                            <Table.Td style={{ width: col.width }}>
                              {!(
                                isCustomSourceAllocation &&
                                values[
                                  fields.customizeAllocationCalculationMethod
                                ] === 2
                              ) ? (
                                <>{_[col.columnName]}</>
                              ) : (
                                <Field
                                  size="xs"
                                  isRequired
                                  disabled={true}
                                  type="text"
                                  autoComplete="off"
                                  value={_[col.columnName]}
                                  precision={2}
                                  component={FieldInputDollar}
                                />
                              )}
                            </Table.Td>
                          );
                        }

                        const investmentFound = get(
                          sourceAvailableFromFilteredSourceBalances,
                          "sourceInvestmentBalances",
                          []
                        ).find((x) => x.investmentId === _.investmentId);

                        return (
                          <Table.Td style={{ width: col.width }}>
                            <div style={{ whiteSpace: "nowrap" }}>
                              {col.columnName ===
                              "investmentAvailableAmount" ? (
                                investmentFound?.sourceEmployeeInvestmentMap?.accountBalance?.toFixed(
                                  2
                                )
                              ) : col.columnName ===
                                "investmentNetWithdrawalAmount" ? (
                                <div style={{ marginLeft: "20px" }}>
                                  {(
                                    (_?.sourceEmployeeInvestmentMap
                                      ?.accountBalance *
                                      netAmountWithdrawnFromSource) /
                                    grossAmountWithdrawnFromSource
                                  )?.toFixed(2)}
                                </div>
                              ) : col.columnName ===
                                "investmentGrossWithdrawalAmount" ? (
                                <div style={{ marginLeft: "20px" }}>
                                  {_?.sourceEmployeeInvestmentMap?.accountBalance?.toFixed(
                                    2
                                  )}
                                </div>
                              ) : (
                                _[col.columnName]
                              )}
                            </div>
                          </Table.Td>
                        );
                      })}
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          </div>
        </div>
      </WithdrawalExpandableCard>
    </>
  );
}

export default SourceAllocationTableComponent;
